<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      resizable
      border
      size="small"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :row-id="'amzFlipOrderCode'"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyTime }}</span>
      </template>
      <template v-slot:skuSalesChannel="{ row }">
        <el-tag size="mini"> {{ row.v_skuSalesChannel }}</el-tag>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.amzFlipOrderStatus == 'N'
              ? 'info'
              : row.amzFlipOrderStatus == 'S'
              ? ''
              : row.amzFlipOrderStatus == 'P'
              ? 'success'
              : row.amzFlipOrderStatus == 'R'
              ? 'danger'
              : row.amzFlipOrderStatus == 'D'
              ? 'danger'
              : row.amzFlipOrderStatus == 'T'
              ? ''
              : row.amzFlipOrderStatus == 'A'
              ? 'success'
              : row.amzFlipOrderStatus == 'B'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_amzFlipOrderStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import { format } from '@/libs/util.number.js'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      switch (menuType) {
        case 'detail':
          this.$emit('openEditPage', { pageType: menuType, data })
          break
        case 'review':
          this.$emit('openEditPage', { pageType: menuType, data })
          break
        case 'purchase':
          this.purchase(data.amzFlipOrderCode)
          break
        case 'cancel-purchase':
          this.cancelPurchase(data)
          break
      }
    },
    onCheckboxChange({ records, reserves }) {
      this.$emit('choose-change', records.concat(reserves))
    },
    purchase(amzFlipOrderCode) {
      this.$confirm(
        this.$l('tips_purchase') || '是否要提交采购？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        if (this.loadingOpen()) return
        this.$api
          .ecomAmzFlipOrderPurchaseApi({
            amzFlipOrderCode,
          })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status == 200) {
              this.$message({
                showClose: true,
                message:
                  this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
                type: 'success',
              })
            }
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    async cancelPurchase({ amzFlipOrderCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_cancelPurchase') || '是否取消该采购申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确认',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzFlipOrderCancelPurchaseApi({ amzFlipOrderCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_cancel_no') || '取消失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_cancel_ok') || '取消成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
